module.exports = __webpack_public_path__ + "img/banner4.9a1e20e5.png";